import { render } from "./projectsecret.vue?vue&type=template&id=d36922bc"
import script from "./projectsecret.vue?vue&type=script&lang=js"
export * from "./projectsecret.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__